import React from "react";
import PropTypes from "prop-types";
import {Modal} from 'react-bootstrap'
import {confirmable, createConfirmation} from 'react-confirm'
import '../../style/component/modal/modal.css'
import SVGraphics from "../../assets/SVGraphics";

class ErrorModalWithCancel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            url: null,
            isErr: false
        }
    }


    render() {
        let {
            title,
            message,
            show,
            proceed,
            btn,
            btn2
        } = this.props;
        return (
            <Modal
                size="lg"
                show={show}
                centered={true}
                onHide={() => proceed()}
                dialogClassName={'exit-session-dialog'}
                contentClassName={'exit-session-content'}
                backdrop={false}
                keyboard={true}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <div className={'exit-session-btn-container modal-close pointer'} onClick={() => proceed(false)}>
                    <SVGraphics svgname={'close'} className={'modal-close-btn'}/>
                </div>
                <Modal.Body className={'exit-session-media-body'}>
                    <div className={'modal-message-header'}>{title}</div>
                    <div className={'modal-message-body'}>
                        {String(message).split("\n").map((i, key) => {
                            return <div key={key}>{i}</div>;
                        })}
                    </div>
                    <div className={'modal-message-footer modal-confirm-buttons'}>
                        {!btn&&<button className={'btn mhd-btn mhd-btn-outline'} onClick={() => proceed(true)}>Ok</button>}
                        {btn&&<button className={'btn mhd-btn  mhd-reset-btn'} onClick={() => proceed(true)}>{btn}</button>}
                        <button className={'btn mhd-btn '} onClick={() => proceed(false)}>Cancel</button>
                        {btn2&&<button className={'btn mhd-btn mhd-reset-btn'} onClick={() => proceed(true)}>{btn2}</button>}

                    </div>

                </Modal.Body>
            </Modal>
        );
    }
}

ErrorModalWithCancel.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
};

export default function MakeErrorConfirm({title,message,btn=null,btn2=null} = {
                                      title: title = 'Error',
                                      message: message = "Error, please refresh the page"
                                  }) {
    return createConfirmation(confirmable(ErrorModalWithCancel))({
        title,
        message,
        btn,
        btn2
    });
}
